<template>
   <svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.36 13.41l-6.13 6.13a.8.8 0 01-1.05.06l-.08-.06L.98 13.4l1.13-1.13 4.76 4.76V.6h1.6v16.44l4.76-4.76 1.13 1.13-6.13 6.13zm.39 11.84H.25v-1.5h14.5v1.5z"/>
   </svg>
</template>

<script>
export default {
   name: 'DownloadIcon'
}
</script>